import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Buton, Kart, MetinAlani, Secim } from "@koclukpanel/ui";
import { api } from "./api";

const TURLER = {
  ACCESS: "Bilgi talebi",
  RECTIFICATION: "Düzeltme",
  ERASURE: "Silme",
  PORTABILITY: "Veri taşınabilirliği",
  OBJECTION: "İşlemeye itiraz",
  RESTRICTION: "İşlemenin sınırlandırılması",
};
const DURUMLAR: Record<string, string> = {
  RECEIVED: "Alındı",
  IN_PROGRESS: "İnceleniyor",
  COMPLETED: "Sonuçlandı",
  REJECTED: "Reddedildi",
};
type Basvuru = {
  id: string;
  kind: keyof typeof TURLER;
  detail: string;
  status: string;
  resolution: string | null;
};

export function KvkkBasvurularim() {
  const qc = useQueryClient();
  const [tur, setTur] = useState<keyof typeof TURLER>("ACCESS");
  const [ayrinti, setAyrinti] = useState("");
  const liste = useQuery({
    queryKey: ["kvkk-basvurularim"],
    queryFn: () => api<{ basvurular: Basvuru[] }>("/kvkk/basvurular"),
  });
  const ac = useMutation({
    mutationFn: () =>
      api("/kvkk/basvurular", { yontem: "POST", govde: { tur, ayrinti: ayrinti.trim() } }),
    onSuccess: async () => {
      setAyrinti("");
      await qc.invalidateQueries({ queryKey: ["kvkk-basvurularim"] });
    },
  });
  return (
    <Kart className="flex flex-col gap-3">
      <h2>KVKK başvurularım</h2>
      <form
        className="flex flex-col gap-3"
        onSubmit={(e) => {
          e.preventDefault();
          ac.mutate();
        }}
      >
        <Secim
          etiket="Başvuru türü"
          value={tur}
          onChange={(e) => setTur(e.target.value as keyof typeof TURLER)}
        >
          {Object.entries(TURLER).map(([deger, ad]) => (
            <option key={deger} value={deger}>
              {ad}
            </option>
          ))}
        </Secim>
        <MetinAlani
          etiket="Açıklama"
          value={ayrinti}
          onChange={(e) => setAyrinti(e.target.value)}
          required
          minLength={10}
          maxLength={5000}
        />
        <Buton type="submit" disabled={ac.isPending || ayrinti.trim().length < 10}>
          Başvuru aç
        </Buton>
      </form>
      {ac.isSuccess && <p role="status">Başvurunuz alındı.</p>}
      {(ac.error || liste.error) && <p role="alert">{(ac.error || liste.error)?.message}</p>}
      {liste.isPending && <p role="status">Başvurular yükleniyor…</p>}
      {liste.isError && <Buton onClick={() => void liste.refetch()}>Tekrar dene</Buton>}
      {liste.data?.basvurular.length === 0 && <p>Henüz başvurunuz yok.</p>}
      <ul>
        {liste.data?.basvurular.map((b) => (
          <li key={b.id}>
            <strong>
              {TURLER[b.kind]} — {DURUMLAR[b.status] ?? b.status}
            </strong>
            <p>{b.detail}</p>
            {b.resolution && <p>{b.resolution}</p>}
          </li>
        ))}
      </ul>
    </Kart>
  );
}
